import { lazy, Suspense, memo } from 'react';

// Lazy-load lottie-react to avoid loading entire animation library upfront
const LottieComponent = lazy(() => import('lottie-react'));

// Fallback component while lottie is loading
const LottieLoadingFallback = memo(() => {
  return <div style={{ width: '100%', height: '100%', backgroundColor: '#f5f5f5' }} />;
});

LottieLoadingFallback.displayName = 'LottieLoadingFallback';

// Export wrapped component
export const LazyLottie = memo(({ animationData, ...props }) => {
  return (
    <Suspense fallback={<LottieLoadingFallback />}>
      <LottieComponent animationData={animationData} {...props} />
    </Suspense>
  );
});

LazyLottie.displayName = 'LazyLottie';
